export default "__VITE_ASSET__Nm$VWBJB__"